import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ASSET_ATTRIBUTE_EDITOR_CLASS_NAME = 'AssetAttributeEditor';
export const ASSET_ATTRIBUTE_EDITOR_CLASS_SLOTS = [
	'root',
	'attributesWrapper',
	'form',
	'footer',
	'selector',
] as const;

export type AssetAttributeEditorClassSlot =
	(typeof ASSET_ATTRIBUTE_EDITOR_CLASS_SLOTS)[number];

export interface AssetAttributeEditorClasses {
	root: string;
	attributesWrapper: string;
	form: string;
	footer: string;
	selector: string;

	disabled: string;
}

export type AssetAttributeEditorClassKey = keyof AssetAttributeEditorClasses;

export const getAssetAttributeEditorUtilityClass = (slot: string) =>
	generateUtilityClass(ASSET_ATTRIBUTE_EDITOR_CLASS_NAME, slot);

export const assetAttributeEditorClasses: AssetAttributeEditorClasses =
	generateUtilityClasses(ASSET_ATTRIBUTE_EDITOR_CLASS_NAME, [
		'root',
		'attributesWrapper',
		'disabled',
		'form',
		'footer',
		'selector',
	]);

export default assetAttributeEditorClasses;
